import React, { useContext, useState } from "react";
import { StoreContext } from "../../context/StoreContext";
import { SearchInput } from "../../components/componentsList";
import { useHistory } from "react-router-dom";

const Search = () => {
  const { state, actions } = useContext(StoreContext);
  const history = useHistory();

  const [searchInputGiven, setSearchInputGiven] = useState(false);

  const activateSearch = (e) => {
    process.env.Module === "dev"
      ? history.push("/membersearch/results")
      : (window.location.href =
          "https://www.technieknederland.nl/ledenzoek-resultaat");
  };

  function storeInput(value, inputCategory) {
    actions.setSearchInput(value, inputCategory);
    value.Name.length > 0
      ? setSearchInputGiven(true)
      : setSearchInputGiven(false);
  }

  function sortSuggestions(dataToSort) {
    return dataToSort.sort((a, b) => (a.Name > b.Name ? 1 : -1));
  }

  return (
    <section className="search-box">
      {state.search.suggestionsLoaded &&
        state.search.suggestions &&
        state.search.searchInput && (
          <>
            <SearchInput
              inputID="company"
              placeHolder="Zoek op opdracht of bedrijf"
              classes="company"
              suggestions={[
                {
                  keywords: sortSuggestions(
                    state.search.suggestions.MappingKeywordAttribute
                  ),
                },
                {
                  qualitySchemes: sortSuggestions(
                    state.search.suggestions.Kwaliteitsregelingen
                  ),
                },
                {
                  companies: sortSuggestions(
                    state.search.suggestions.Companies
                  ),
                },
              ]}
              iconFunction={(e) => activateSearch(e)}
              storeInput={storeInput}
              defaultValueForInput={
                state.search.searchInput.company
                  ? state.search.searchInput.company
                  : {}
              }
              useGeo={false}
              tooltipIcon=""
            />
            <SearchInput
              inputID="place"
              placeHolder="Vul uw plaats of postcode in"
              classes="location"
              suggestions={[
                { Places: sortSuggestions(state.search.suggestions.Places) },
              ]}
              storeInput={storeInput}
              defaultValueForInput={
                state.search.searchInput.place
                  ? state.search.searchInput.place
                  : {}
              }
              useGeo={true}
              tooltipIcon="Bepaal mijn coördinaten"
            />
            {searchInputGiven && (
              <a className="btn" onClick={activateSearch}>
                Vind een vakman
              </a>
            )}
            {!searchInputGiven && (
              <a className="btn disabled">Vind een vakman</a>
            )}
          </>
        )}
    </section>
  );
};

export { Search };
